export const MESSAGE_PROMOTE_SUCCESS =
  'Success! Family has been promoted. Confirmation id: '
export const MESSAGE_PROMOTE_SELECT_ERROR =
  'Please select a Family prior to promoting.'
